const MIME_TO_ICON: Partial<Record<string, string>> = {
  'application/vnd.ms-excel': 'file-xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    'file-xlsx', // .xlsx
  'application/vnd.ms-excel.sheet.macroenabled.12': 'file-xlsm', // .xlsm
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'file-docx', // .docx
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'file-unknown', // .pptx
  'text/csv': 'file-csv', // .csv
  'text/plain': 'file-unknown', // .txt
  'text/html': 'file-unknown', // .html
  'application/zip': 'file-zip', // .zip
  'application/pdf': 'file-pdf', // .pdf
  'application/json': 'file-unknown', // .json
  'video/mp4': 'file-unknown', // .mp4
  'image/png': 'file-png', // .png
  'image/jpeg': 'file-jpg', // .jpg
  'image/gif': 'file-png', // .gif
  csv: 'file-csv',
  jpeg: 'file-jpg',
  jpg: 'file-jpg',
  pdf: 'file-pdf',
  png: 'file-png',
  xls: 'file-xls',
  xlsx: 'file-xlsx',
};

export function mapMimeTypeToSVGIconName(mimetype?: string) {
  return mimetype
    ? (MIME_TO_ICON[mimetype.toLowerCase()] ?? 'file-unknown')
    : 'file-unknown';
}
